<div class="qaroni-table-responsive w-full">
  <table class="block w-full md:table">
    <thead class="hidden md:table-header-group">
      <tr>
        <th class="border-b p-2 align-bottom" scope="col" i18n>Día</th>
        <th class="border-b p-2 align-bottom" scope="col"></th>
        <th
          class="border-b p-2 text-start align-bottom md:px-10"
          scope="col"
          i18n>
          Turnos trabajados
        </th>
        <th class="border-b p-2 text-center align-bottom" scope="col" i18n>
          Horas trabajadas
        </th>
        <th class="border-b p-2 text-center align-bottom" scope="col" i18n>
          Horas de Descanso
        </th>
        <th class="border-b p-2 text-center align-bottom" scope="col" i18n>
          Horas Acumuladas
        </th>
      </tr>
    </thead>
    <tbody class="block md:table-row-group">
      <ng-content />
    </tbody>
  </table>
</div>
